<template>
  <div id="app">
    <xyy-header v-if="!hideHeaderFooter"></xyy-header>
    <router-view/>
    <xyy-footer v-if="!hideHeaderFooter"></xyy-footer>
    <xyy-hotline v-if="!hideHeaderFooter"></xyy-hotline>
  </div>
</template>

<script>
import header from './components/base/xyy-header.vue'
import footer from './components/base/xyy-footer.vue'
import hotline from './components/base/xyy-hotline.vue'
export default {
  name: 'App',
  components: {
    'xyy-header': header,
    'xyy-footer': footer,
    'xyy-hotline': hotline
  },
  computed: {
    hideHeaderFooter () {
      // 判断当前路由是否匹配 /tracking
      return this.$route.path === '/tracking' ||
             this.$route.matched.some(route => route.meta && route.meta.hideHeaderFooter)
    }
  }
}
</script>
<style>
  #app {
    min-width: 1340px;
  }
    body{
        padding:0px;
        margin: 0px;
        border: 0px;
        background-color: #efefef;
    }

    body *{font-family: "Montserrat", "Microsoft YaHei", "PingFang SC","NotoSansSC", "Microsoft JhengHei", Arial;}
</style>



// WEBPACK FOOTER //
// src/App.vue